import { generatePath } from "react-router-dom";
import { routes } from "../../../constants/routes";

export default function prismicLinkResolver(doc) {
  if (doc.type === "landing_page") {
    return `${routes.landingPage.path}/${doc.uid}`;
  }

  if (doc.type === "blog_post") {
    return `${routes.blog.path}/${doc.uid}`;
  }

  if (doc.type === "blog_category") {
    return `${routes.blogCategory.path}/${doc.uid}`;
  }

  // Using generate path, just in case this ever stops being a top-level page
  if (doc.type === "campaign_page") {
    try {
      return generatePath(routes.campaignPage.path, { slug: doc.uid });
    } catch (err) {}
  }

  return "/";
}
